/**
 * App config
 * @module config
 */

const localStorageEntryName = 'bg-rock-archives'
let localData = localStorage.getItem(localStorageEntryName)

if (localData) {
  localData = JSON.parse(localData)
}

const config = {
  localStorageEntryName, // name for the local storage entry
  root: 'https://afternoon-headland-14623.herokuapp.com/api', // 'http://127.0.0.1:5000/api', // API root
  siteTitle: 'Български рок архиви', // site title, displayed on the application bar
  gridRowsPerPage: 20, // number of rows to show on pages with grid
  showRegionsMap: false, // show clickable map of Bulgaria on the /regions page
  reloadAppOnSettingsSave: false, // reload the app on saving the local settings
  contacts: {
    facebook: 'https://www.facebook.com/BgRockArchives/', // facebook page
    email: 'contact@bg-rock-archives.com' // contact email
  },
  googleAnalyticsId: 'UA-17572030-33', // Google Analytics / Gtag ID
  dark: localData ? localData.dark : true // dark or light theme, set automatically
}

export default config



// WEBPACK FOOTER //
// ./src/helpers/config.js